import { fetchStocks } from "./inventoryAction";
import { formatData } from "./utils";

export const fetchSaleCredits = () => {
    console.log("FIRED ACTION FETCH SALES" )
    return async dispatch => {
        dispatch({
            type: "FETCH_SALES_CREDITS_START",
            payload: ""
        })
            
        try {
            const response = await fetch('/stocks/getList/other',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"credit/sales",
                }),
                credentials: 'same-origin',
            }); 
            
            const creditsList = await response.json()
            console.log(creditsList)// creditsList returns new object created
            console.log("creditsList",{creditsList})// creditsList returns new object created

            if(!creditsList.error){ // no errors, return new Object
                dispatch(getSaleCredits(formatData(creditsList.reverse()) ))
                dispatch({ type: "FETCH_SALES_CREDITS_FULFILLED", payload:"" })
                console.log("credits fetched")            
            } else {
                dispatch({
                    type: "FETCH_SALES_CREDITS_ERROR",
                    payload: creditsList.error.message
                })
            }
        } catch (err) {
            dispatch({
                type: "FETCH_SALES_CREDITS_ERROR",
                payload: err
            })
        }
    }
}
export const createSaleCredit = (newSaleCredit) => {
    console.log("FIRED ACTION CREATE SALE", newSaleCredit)
    return async dispatch => {
        dispatch({
            type: "CREATE_SALE_CREDIT_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page: "credit/sales",
                    data: newSaleCredit
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSaleCredit = await response.json()
            console.log(createdSaleCredit)// createdSaleCredit returns new object created

            if(createdSaleCredit.id){ // no errors, return new Object
                dispatch({
                    type:"NEW_SALE_CREDIT",
                    payload: createdSaleCredit
                })
                dispatch({ type: "CREATE_SALE_CREDIT_FULFILLED", payload:"" })                
            } else {
                dispatch({
                    type: "CREATE_SALE_CREDIT_ERROR",
                    payload: createdSaleCredit.error.message
                })
            }
        } catch (err) {
            console.log('====================================');
            console.log("error create credit", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_SALE_CREDIT_ERROR",
                payload: err
                
            })
        }
    }
}

export const deleteCredit = (credit) => {
    return async dispatch => {
        dispatch({ type: "DELETE_SALE_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type: "credit",
                    data: credit
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE SALE_CREDIT RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_SALE_CREDIT", payload: credit.op_id })
                dispatch({ type: "DELETE_SALE_CREDIT_FULFILLED", payload:"" })
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "DELETE_SALE_CREDIT_ERROR",
                    payload: body.error.message
                })
            }
        } catch (err) {
            dispatch({  type: "DELETE_SALE_CREDIT_ERROR", payload: err })
        }
    }
}

export const getSaleCredits = (list) => {
    return {
        type: "GET_SALE_CREDITS",
        payload: list
    }
}
export const getSaleCredit = (credit_Id) => {
    return {
        type: "GET_SALE_CREDIT",
        payload: credit_Id
        
    }
}

export function unLinkCreditPaymentsTo5000(data) {
    return async function (dispatch) {
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" });
        try {
            // Un seul appel : le serveur enchaîne storehouse puis la comptabilité 5000.
            const req = await fetch('/stocks/compta/credits/unlink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_SALES_ERROR", payload: res.error });
                return { ok: false, error: res.error };
            }

            Object.keys(data.id_list || {}).forEach((creditId) => {
                dispatch({
                    type: "UPDATE_SALE_CREDIT",
                    payload: { id: creditId, income_id: "", fact_id_5000: "", amount_linked: 0 },
                });
            });
            dispatch({ type: "LINK_SALES_FULFILLED", payload: "" });
            // `warning` : dépointage fait côté 8000 seul, l'écriture 5000 n'existant plus.
            return { ok: true, warning: res.warning };
        } catch (error) {
            console.log("[ERROR] unlink credit payments from compta:", error);
            dispatch({ type: "LINK_SALES_ERROR", payload: error.message });
            return { ok: false, error: error.message };
        }
    };
}

export function linkCreditPaymentsTo5000(data) {
    return async function (dispatch, getState) {
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" });
        try {
            // Un seul appel : le serveur enchaîne storehouse puis la comptabilité 5000 et annule
            // le pointage si le 5000 ne répond pas. L'appel au 5000 était fait ici, après coup, et
            // son échec était réduit à un console.log — le crédit restait pointé côté 8000 pendant
            // que la recette gardait la totalité de son reste à pointer, sans que personne le sache.
            const req = await fetch('/stocks/compta/credits/link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            const res = await req.json();

            if (res.error) {
                dispatch({ type: "LINK_SALES_ERROR", payload: res.error });
                // Rendu à l'appelant : l'écran ne peut pas lire l'erreur dans le store juste
                // après l'await, il y verrait la valeur capturée au rendu précédent.
                return { ok: false, error: res.error };
            }

            const creditIds = Object.keys(data.id_list || {});
            const state = getState && getState();
            const saleCredits = (state && state.inventory && state.inventory.credits) || {};
            creditIds.forEach((creditId) => {
                const existing = saleCredits[creditId] || {};
                const prevLinked = parseFloat(existing.amount_linked || 0) || 0;
                const addAmount = parseFloat((data.id_list || {})[creditId] || 0) || 0;
                dispatch({
                    type: "UPDATE_SALE_CREDIT",
                    payload: {
                        id: creditId,
                        income_id: data.income_id,
                        fact_id_5000: data.income_id,
                        amount_linked: prevLinked + addAmount
                    }
                });
            });
            dispatch({ type: "LINK_SALES_FULFILLED", payload: "" });
            return { ok: true };
        } catch (error) {
            console.log("[ERROR] link credit payments to compta:", error);
            dispatch({ type: "LINK_SALES_ERROR", payload: error.message });
            return { ok: false, error: error.message };
        }
    };
}
